import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import SearchInput from '../search-input';
import ChatInput from './chat-input';
import ChatBubble from '../chat-bubble';
import { ChatWindowSC, ChatGroupTitleSC } from './chat-window.styled';
import TStore from '../../types/store';
import { TMessage } from '../../types/rooms';
import { TAttachment } from '../../types/attachments';
import { sendRoomMessage, sendRoomAttachment } from '../../helpers/strophe-helpers';
import { TUserPreview } from '../../types/users';
import { getDateFormat, groupMessagesByDate } from '../../helpers/utils-helpers';
import EnvService from '@services/internal/env';

type TProps = {
  roomMessages: TMessage[];
  searchHistory: TUserPreview[];
  disabledSubmit: boolean;
};

const ChatWindow: React.FC<TProps> = ({ roomMessages, searchHistory, disabledSubmit }) => {
  const scrollView: any = useRef(null);

  const scrollToBottom = () => {
    scrollView.current.scrollTop = scrollView.current.scrollHeight;
  };

  const isSequence = (previousMessage: TMessage | null, currentMessage: TMessage): boolean => {
    if (previousMessage === null) {
      return false;
    }
    if (previousMessage.sender === 'me' && currentMessage.sender === 'me') {
      return true;
    }
    if (previousMessage.sender === '' && currentMessage.sender === '') {
      return true;
    }
    return previousMessage.sender === 'other' && previousMessage.from === currentMessage.from;
  };

  const renderGroups = () => {
    return groupMessagesByDate(roomMessages).map((group: any) => (
      <div key={group.date}>
        <ChatGroupTitleSC>
          <span>{moment(group.date).format(getDateFormat())}</span>
        </ChatGroupTitleSC>
        {renderMessages(group.messages)}
      </div>
    ));
  };

  const renderMessages = (messages: TMessage[]) => {
    let previousMessage: TMessage | null = null;
    return messages.map((message, index) => {
      let nickname = '';
      const sequence = isSequence(previousMessage, message);
      // TODO: Idiotic way
      const user = searchHistory.find((user) => user.jabberId === message.from);
      if (user) {
        nickname = `${user.profile.firstName} ${user.profile.lastName}`;
      }
      let isMe: boolean = message.sender === 'me' || message.sender === '';
      previousMessage = message;

      // Hilbi Correction TODO: cele prepisat sak toto je ...
      if (message.from === EnvService.getSnapshot().xmpp.hilbiJid) {
        isMe = false;
        nickname = 'Hilbi';
      }

      return (
        <ChatBubble
          stamp={message.stamp}
          avatarUrl={user?.profile.profileImage}
          text={message.text}
          from={nickname}
          isMe={isMe}
          key={index}
          isSequence={sequence}
          attachment={message.attachment}
        />
      );
    });
  };

  const onMessageSubmit = async (message: string, attachment?: TAttachment) => {
    if (message.trim() === '' && !attachment) {
      return;
    }
    if (attachment) {
      await sendRoomAttachment(message, attachment);
    } else {
      await sendRoomMessage(message);
    }
  };

  useEffect(scrollToBottom, [roomMessages]);

  return (
    <ChatWindowSC>
      <div className="chw-topbar">
        <SearchInput isBlock />
      </div>
      <div className="chw-chat">
        <div className="chw-scrollable" ref={scrollView}>
          {renderGroups()}
        </div>
      </div>
      <div className="chw-bottom-bar">
        <ChatInput onSubmit={onMessageSubmit} disabledSubmit={disabledSubmit} />
      </div>
    </ChatWindowSC>
  );
};

const mapStateToProps = (store: TStore) => ({
  roomMessages: store.rooms.messages,
  searchHistory: store.users.searchHistory,
  disabledSubmit: store.rooms.disabledSubmit,
});

export default connect(mapStateToProps)(ChatWindow);
